import { useLocation, useNavigate } from 'react-router-dom'
import React, { useEffect, useRef, useState } from 'react'
import { useOrderInfo } from 'contexts/OrderInfoContext'
import { useAuth } from 'contexts/AuthContext'
import SigninForm from 'pages/Signin/Form'
import LoginForm from './Form'
import './index.scss'

interface LoginProps {
  orderId?: string
}

const Login: React.FC<LoginProps> = ({ orderId }) => {
  const { isAuth } = useAuth()
  const { search } = useLocation()
  const [, orderData] = useOrderInfo()

  const query = new URLSearchParams(search)
  const emailFromUrl = query.get('email')
  const order_id = orderId || query.get('order_id')

  const [isAlert, showAlert] = useState(!!emailFromUrl)
  const [isLoginForm, showLoginForm] = useState(!order_id)
  const [email, setEmail] = useState(emailFromUrl || '')

  const navigate = useNavigate()
  const formRef = useRef<HTMLDivElement>(null)


  useEffect(() => {
    if (isAuth) {
      navigate('/')
    }
  }, [isAuth, navigate])

  return (
    <div className='login__container'>
      <div className='topbar topbar--mobile'>
        <div className="topbar__wrap">
          <div className="topbar__logo">
            <h1>Moje Kondolencje</h1>
          </div>
          <button
            className='btn btn--round'
            style={{ backgroundColor: 'var(--on-bg-sec-color)' }}
            onClick={() => {
              window.open('https://mojekondolencje.pl/', '_self')
            }}>
            Sklep
          </button>
        </div>
      </div>

      <div className='login'>
        {order_id
          ? <div className='login__order'>
            <div>
              <div className='login__banner'>
                <i className='icon icon--package' />
                <h1>{!orderData?.is_paid ? 'Zamówienie nieopłacone' : 'Zamówienie opłacone'}</h1>
              </div>

              {orderData?.is_paid
                ? <div>
                  <h1>Co teraz?</h1>
                  <div
                    className='login__step'
                    onClick={() => {
                      formRef.current?.scrollIntoView({ behavior: 'smooth' })
                    }}>
                    <span>1</span>
                    <span>Zaloguj lub zarejestruj się do aplikacji</span>
                  </div>
                  <div className='login__step'>
                    <span>2</span>
                    <span>Wypełnij formularz dodawania profilu</span>
                  </div>
                </div>
                : <div>
                  <h1>Co teraz?</h1>
                  <div
                    className='login__step'
                    onClick={() => {
                      navigate('/order')
                    }}>
                    <span>1</span>
                    <span>Spróbuj ponownie dokonać zakupu</span>
                  </div>
                  <div
                    className='login__step'
                    onClick={() => {
                      formRef.current?.scrollIntoView({ behavior: 'smooth' })
                    }}>
                    <span>2</span>
                    <span>Zaloguj lub zarejestruj się do aplikacji</span>
                  </div>
                  <div className='login__step'>
                    <span>3</span>
                    <span>Wypełnij formularz dodawania profilu</span>
                  </div>
                </div>}

              {orderData?.is_paid && <div>
                <h1>Chcesz zrobić to później?</h1>
                <div className='login__block'>
                  Jeżeli chcesz zrobić to później, w każdej chwili możesz kliknąć
                  w link z wiadomości e-mail i uzupełnić profil
                </div>
                <div className='login__block'>
                  Alternatywnie, możesz poczekać na przesyłkę, zeskanować
                  tabliczkę aparatem i wtedy uzupełnić profil
                </div>
              </div>}

              {orderData?.is_paid && <div>
                <h1>Zakupiona tabliczka jest dla kogoś innego?</h1>
                <div className='login__block'>
                  Nie loguj się! tabliczka jest opłacona. Obdarowana osobą przypisze ją
                  do swojego konta.
                </div>
              </div>}
            </div>
          </div>
          : <div className='login__desktop' />}

        <div
          ref={formRef}
          className='login__form'>
          {isLoginForm
            ? <LoginForm
              email={email}
              isAlert={isAlert}
              blockGuestLoginOptions={!!order_id}
              setEmail={setEmail}
              hideAlert={() => {
                showAlert(false)
              }}
              showRegistrationForm={() => {
                if (order_id) showLoginForm(false)
                else navigate('/signin')
              }}
            />
            : <SigninForm
              email={email}
              setEmail={setEmail}
              showLoginForm={(email) => {
                showLoginForm(true)
                if (email) {
                  showAlert(true)
                }
              }}
            />}
        </div>
      </div>
    </div>
  )
}

export default Login